import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import SchedulePageSkeleton from './SchedulePageSkeleton'

const SchedulePagePlaceholder = () => {
  return (
    <SchedulePageSkeleton
      titleSection={
        <LoadingBox width="150px" variant="text.h3">
          &nbsp;
        </LoadingBox>
      }
      upcomingLessonsSection={
        <LoadingBox width="100%" height="150px" borderRadius="1x" />
      }
      tutorListSection={
        <LoadingBox width="100%" height="150px" borderRadius="1x" />
      }
      calendarSection={
        <LoadingBox width="100%" height="254px" borderRadius="1x" />
      }
    />
  )
}

export default SchedulePagePlaceholder
